export const defaultState = {
  isBillable: null,
  billingCategory: null,
  duration: undefined,
  hadLiveInteraction: null,
  reason: undefined,
  serviceAt: null,
};

export const editableFields = [
  'isBillable',
  'billingCategory',
  'duration',
  'hadLiveInteraction',
  'serviceAt',
];

export const booleanFields = ['isBillable', 'hadLiveInteraction'];

export const textFields = ['billingCategory', 'reason', 'serviceAt'];
